<template>
  <div class='SelectFrenteLoja'>
    <div class="text">
      {{ Empresa.frenteloja ? 'Ativo' : 'Desativado' }}
    </div>
    <div class="btn">
      <button @click="_UpdateFrenteLoja({ frenteloja: !Empresa.frenteloja })">{{ Empresa.frenteloja ? 'Desativar' : 'Ativar' }}</button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'SelectFrenteLoja',
  computed: {
    ...mapGetters(['Empresa'])
  },
  methods: {
    ...mapActions(['_UpdateFrenteLoja'])
  }
}
</script>

<style scoped>
.SelectFrenteLoja {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.text {
  flex: 1;
  text-align: left;
  padding: 10px 12px;
  border: thin solid #CCCCCC;
  border-radius: 5px;
}

.btn {
  width: 150px;
  display: flex;
  justify-content: flex-end;
}

button {
  color: #FFFFFF;
  padding: 8px 16px;
  font-size: 14px;
  background-color: #000000;
  border: 0;
  border-radius: 5px;
  cursor: pointer;
}
</style>
